import { useState, useEffect, React } from "react";
import { Modal, Button } from "react-bootstrap";
import { installProfile, uploadProfile } from "../../commands/mdmCommands";
import ProfileUploader from "../ProfileUploader";
import plist from "plist";
import ProfilePayload from "../ProfilePayload";

function InstallProfileModal({
  visible,
  UDID,
  currentProfiles,
  configProfiles,
  hideInstallProfileModal,
}) {
  const [show, setShow] = useState(false);
  const [profile, setProfile] = useState();
  const [selectedConfigProfile, setSelectedConfigProfile] = useState(null);
  const [plistData, setPlistData] = useState(null);
  const [parseError, setParseError] = useState(false);
  const [profileAlreadyInstalled, setProfileAlreadyInstalled] = useState(false);

  const handleClose = () => {
    setShow(false);
    hideInstallProfileModal();
  };

  useEffect(() => {
    setShow(visible);
  }, [visible]);

  useEffect(() => {
    if (profile) {
      setParseError(false);
      try {
        const decoded = atob(profile);
        setPlistData(plist.parse(decoded));
      } catch {
        try {
          setPlistData(plist.parse(profile));
        } catch {
          setPlistData(null);
          setParseError(true);
        }
      }
    } else {
      setPlistData(null);
      setParseError(false);
    }
  }, [profile]);

  useEffect(() => {
    const identifier = plistData?.PayloadIdentifier ?? selectedConfigProfile?.PayloadIdentifier;
    if (identifier && UDID && Array.isArray(currentProfiles)) {
      const installed = (currentProfiles || []).some((p) => p.PayloadIdentifier === identifier);
      setProfileAlreadyInstalled(installed);
    } else {
      setProfileAlreadyInstalled(false);
    }
  }, [plistData, selectedConfigProfile, UDID, currentProfiles]);

  function deployProfile() {
    if (!profile) return;
    const meta = plistData || selectedConfigProfile;
    const profileObject = {
      PayloadDisplayName: meta?.PayloadDisplayName ?? 'Unbekannt',
      PayloadDescription: meta?.PayloadDescription ?? '',
      PayloadOrganization: meta?.PayloadOrganization ?? '',
      PayloadIdentifier: meta?.PayloadIdentifier ?? '',
      PayloadUUID: meta?.PayloadUUID ?? '',
      MobileConfigData: profile,
    };
    if (UDID) {
      installProfile(UDID, profileObject);
    } else {
      uploadProfile(profileObject);
    }
    handleClose();
  }

  function returnBase64String(str) {
    setProfile(str);
    setSelectedConfigProfile(null);
  }

  function selectConfigProfile(configProfile) {
    const data = typeof configProfile === 'string' ? configProfile : configProfile?.MobileConfigData;
    setSelectedConfigProfile(typeof configProfile === 'object' ? configProfile : null);
    setProfile(data);
  }

  return (
    <>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>{UDID ? "Install" : "Upload"} profile</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {!plistData && !profile && UDID ? (
            configProfiles?.length > 0 ? (
              <table className='table tableList'>
                <tbody>
                  {configProfiles
                    .filter((configProfile) => {
                      let installed = false;
                      (currentProfiles || []).forEach((currentProfile) => {
                        if (
                          currentProfile.PayloadIdentifier ===
                          configProfile.PayloadIdentifier
                        ) {
                          installed = true;
                        }
                      });
                      return !installed;
                    })
                    .map((configProfile, index) => {
                      return (
                        <tr key={configProfile.PayloadIdentifier + index}>
                          <td>
                            <div className='form-check'>
                              <input
                                className='form-check-input'
                                type='checkbox'
                                value=''
                                onChange={() =>
                                  selectConfigProfile(configProfile)
                                }
                              />
                              <label className='form-check-label'>
                                {configProfile.PayloadDisplayName}
                              </label>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            ) : (
              <p className='text-muted'>
                Es sind keine Profile vorhanden. Bitte lade zuerst ein Profil hoch.
              </p>
            )
          ) : null}

          {!profile ? (
            <ProfileUploader returnBase64String={returnBase64String} />
          ) : parseError ? (
            <p className="text-muted">
              Signiertes Profil – Vorschau nicht verfügbar. Das Profil kann dennoch installiert werden.
            </p>
          ) : (
            <ProfilePayload profile={plistData} />
          )}
        </Modal.Body>
        <Modal.Footer>
          {profile && profileAlreadyInstalled ? (
            <p className='errorRed'>
              {(plistData || selectedConfigProfile)?.PayloadDisplayName} is already installed.
            </p>
          ) : null}
          <Button variant='secondary' onClick={handleClose}>
            Close
          </Button>
          {profile && !profileAlreadyInstalled ? (
            <Button variant='warning' onClick={deployProfile}>
              {UDID ? "Install" : "Upload"} Profile
            </Button>
          ) : null}
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default InstallProfileModal;
